import Fuse from 'fuse.js';

const searchOptions = {
  keys: ['title'],
  shouldSort: false,
  threshold: 0.3 // A threshold of 0.0 requires a perfect match, while 1.0 would match anything
};

class ConditionsData {
  letters = undefined;
  conditions = undefined;
  conditionsByLetter = undefined;

  constructor(parent) {
    this.parent = parent;
  }

  async loadConditions() {
    // Conditions are loaded asynchronously mostly to reduce and simplify the code needed in components needing
    // conditions data, and also improve readibility in this store.
    await fetch(
      `${this.parent.app.healthPages.baseUrl}${this.parent.app.healthPages.conditionPagesPath}/`, { mode: 'cors' }
    ).then(async (response)=> {
      this.conditions = await response.json();
      this.conditionsByLetter = this.groupConditionsByLetter(this.conditions);
      this.letters = this.lettersFromConditionGroups(this.conditionsByLetter);
    });

    return;
  }

  all(options = {}) {
    if (options['byLetter'] === true) {
      return this.conditionsByLetter;
    } else {
      return this.conditions;
    }
  }

  letter(letter) {
    if (letter) {
      return this.conditionsByLetter[letter.toUpperCase()] || [];
    } else {
      return this.all();
    }
  }

  search(searchText, options={}) {
    const letter = options['letter'];
    const byLetter = options['byLetter'] === true;
    const dataToSearch = (letter) ? this.letter(letter) : this.conditions;

    if (!dataToSearch) return [];

    const fuse = new Fuse(dataToSearch, searchOptions);

    let searchResults;

    if (searchText) {
      searchResults = fuse.search(searchText);
      searchResults = (byLetter) ? this.groupConditionsByLetter(searchResults) : searchResults;
    } else {
      if (byLetter) {
        searchResults = this.all({ byLetter: true });
      } else {
        searchResults = (letter) ? this.letter(letter) : this.all();
      }
    }

    return searchResults;
  }

  groupConditionsByLetter(conditions) {
    let pagesByLetter = {};

    conditions.forEach((condition) => {
      const letter = condition['letter'];

      if (!pagesByLetter[letter]) {
        pagesByLetter[letter] = [condition];
      } else {
        pagesByLetter[letter].push(condition);
      }
    });

    return pagesByLetter;
  }

  lettersFromConditionGroups(conditionsByLetter) {
    return Object.entries(conditionsByLetter).map((group) => group[0]);
  }
}

export default ConditionsData;
